export const cvrNrStatusMapper = [
  {
    displayName: "Aktiv",
    value: "Aktiv",
  },
  {
    displayName: "Normal",
    value: "NORMAL",
  },
  {
    displayName: "Ophørt",
    value: "Ophørt",
  },
  {
    displayName: "Opløst efter erklæring",
    value: "OPLØSTEFTERERKLÆRING",
  },
  {
    displayName: "Opløst efter frivillig likvidation",
    value: "OPLØSTEFTERFRIVILLIGLIKVIDATION",
  },
  {
    displayName: "Opløst efter fusion",
    value: "OPLØSTEFTERFUSION",
  },
  {
    displayName: "Opløst efter konkurs",
    value: "OPLØSTEFTERKONKURS",
  },
  {
    displayName: "Opløst efter spaltning",
    value: "OPLØSTEFTERSPALTNING",
  },
  {
    displayName: "Slettet",
    value: "SLETTET",
  },
  {
    displayName: "Under frivillig likvidation",
    value: "UNDERFRIVILLIGLIKVIDATION",
  },
  {
    displayName: "Under konkurs",
    value: "UNDERKONKURS",
  },
  {
    displayName: "Under reassumering",
    value: "UNDERREASSUMERING",
  },
  {
    displayName: "Ingen værdi",
    value: "null",
  },
];

export const pNrStatusMapper = [
  {
    displayName: "Aktiv",
    value: "Aktiv",
  },
  {
    displayName: "Ophørt",
    value: "Ophørt",
  },
  {
    displayName: "Ingen værdi",
    value: "null",
  },
];
